import dynamic from 'next/dynamic';

const VersionsDropdown = dynamic(() => import('./VersionsDropdown'));

const Versions: React.FC<{ versions: string[] }> = ({ versions }) => {
  if (versions.length === 1) {
    return <small className="micro font-medium">Version {versions[0]}</small>;
  }

  return <VersionsDropdown versions={versions} />;
};

export default Versions;
